
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventDataSource } from 'src/modules/event/services/event-data-source';
import { EventApiService } from 'src/modules/event/services/event-api-service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CategoryDelete } from '../modals/delete/component';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';

@Component({
    selector: 'category-list',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CategoriesListView implements OnInit, OnDestroy {

  @ViewChild('typeFilter', { static: false })
  public typeFilter: MatButtonToggleGroup;
  private Subscriptions: Subscription[] = [];
  private categoryId: number;
  public loading: boolean;
  public CategoryProducts: [];
  public PageEvent: PageEvent;
  public type: string;
  public displayedColumns = ['title', 'from_price', 'to_price', 'actions'];
  public filterType = 'all';
  public readonly defaultType = 'all';

  public toggles = [
    { label: 'All', value: 'all' },
    // { label: 'Live' },
    // { label: 'Upcoming' },
    { label: 'Expired', value: 'expired' },
  ];
  public DataSource: any;
  constructor(
    private ActivatedRoute: ActivatedRoute,
    protected EventApi: EventApiService
  ) {}
  ngOnInit(): void {
    this.Subscriptions.push(
      this.ActivatedRoute.params.subscribe((params) => {
        const type = this.ActivatedRoute.snapshot.url[1].path;
        this.type = this.capitaliseFirstLetter(type);
        this.categoryId = params['categoryId'];
        this.loadProducts(this.categoryId, type);
      })
    );
  }

  async loadProducts(categoryId, type) {
    this.DataSource = new EventDataSource(
      this.EventApi,
      'event-admin',
      'getCategories',
      { categoryId: categoryId, productType: type }
    );
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_CategoryProducts) => (this.CategoryProducts = _CategoryProducts)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        this.setType(this.defaultType)
      )
    );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('search-string', search);
  }

  public setType(filterType: string) {
    this.DataSource.setFilter('filter-type', filterType);
  }

  public capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  ngOnDestroy(): void {}
}
